import { useEffect } from 'react'
import useAuthHook from 'hooks/use-auth'

const SSO = () => {
  const { isLoading, isAuthenticated, signinRedirect } = useAuthHook()

  useEffect(() => {
    // Persist the current path so SuccessSSO can redirect back after login.
    localStorage.setItem('frompath', globalThis.location.pathname)
    localStorage.removeItem('user_logout')
  }, [])

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      signinRedirect()
    }
  }, [isLoading, isAuthenticated, signinRedirect])

  return <div></div>
}

export default SSO
